import { useLayoutContext } from "client/components/layout"
import CloseButton from "shared/components/buttons/CloseButton"
import { RozyLayout } from "shared/constants/views"
import styled from "styled-components"

import { useChatContext } from "./ChatContext"
import ChatMenu from "./ChatMenu"

const Bar = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.white};

  display: flex;
  justify-content: space-between;
  padding: 4px 10px;
`

const ChatTopBar = () => {
  const { layout } = useLayoutContext()
  const { setIsChatOpen } = useChatContext()

  const handleClose = () => {
    setIsChatOpen(false)
  }

  return (
    <Bar>
      <ChatMenu />
      {layout === RozyLayout.MOBILE && (
        <CloseButton onClose={handleClose} />
      )}
    </Bar>
  )
}

export default ChatTopBar
